import { chain } from "ramda";
import {
  AccountValues,
  getSummedValueLensesById
} from "../derivedModel/accountValues";
import { SpreadFinancialValueLens } from "../derivedModel/spreadFinancialValues";
import { AccountId, SpreadSheetType } from "../spread/types";
import { SelectedCellsState } from "./reducer";
import { SelectedCell } from "./types";

type GetSummedValueLensesByIdFns = {
  [K in SpreadSheetType]: (
    accountId: AccountId
  ) => SpreadFinancialValueLens[][];
};

export const highlightedValueLensesForSelectedCells = (
  getSummedValueLensesByIdFns: GetSummedValueLensesByIdFns,
  selectedCells: SelectedCellsState
): SpreadFinancialValueLens[] =>
  chain(
    selectedCell =>
      selectedCell.account.userEditedByPeriod[selectedCell.period] &&
      !(selectedCell.account.type === "HIDDEN")
        ? []
        : getSummedValueLensesByIdFns[selectedCell.account.spreadSheetType](
            selectedCell.account.id
          )[selectedCell.period],
    selectedCells
  );

export const buildHighlightedValueLensesForSelectedCells = (
  incomeStatementAccountValues: AccountValues,
  balanceSheetAccountValues: AccountValues,
  cashFlowAccountValues: AccountValues,
  selectedCells: SelectedCell[]
) =>
  highlightedValueLensesForSelectedCells(
    {
      BALANCE_SHEET: getSummedValueLensesById(balanceSheetAccountValues),
      INCOME_STATEMENT: getSummedValueLensesById(incomeStatementAccountValues),
      CASH_FLOW: getSummedValueLensesById(cashFlowAccountValues)
    },
    selectedCells
  );



// WEBPACK FOOTER //
// ./src/spread/model/selectedCells/highlightedValueLensesForSelectedCells.ts